import {Image, Text, View} from "react-native";
import { MaterialCommunityIcons } from '@expo/vector-icons';
import * as React from "react";
import {SectionTitle} from "./section-title";

function RecycleItem({ icon, children }) {
    return <View style={{width: 140, alignItems: "center"}}>
        <View style={{width: 100, height: 100, borderRadius: 100, backgroundColor: "#a0ca45", marginBottom: 5, alignItems: 'center', justifyContent: 'center'}}>
            <Image source={icon} />
        </View>
        {/*<Image style={{width: '60%', height: '60%', resizeMode: 'contain', marginBottom: 10}}*/}
        {/*       source={require('../../../../assets/images/why-recycle/food-box.png')}/>*/}
        <Text style={{fontSize: 12, color: "white", textAlign: "center"}}>{children}</Text>
    </View>;
}

export const WhatCanIRecycle = () => (
    <View>
        <SectionTitle>What can I WeCycle ?</SectionTitle>
        <View style={{marginTop: 15}}>
            <View style={{flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-around', marginBottom: 20}}>
                <RecycleItem icon={require('../../../../assets/images/home/icon-paper.png')}>all types of paper&nbsp;/carton packages</RecycleItem>
                <RecycleItem icon={require('../../../../assets/images/home/icon-office.png')}>Office & Paper Leaflets</RecycleItem>
            </View>
            <View style={{flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-around', marginBottom: 20}}>
                <RecycleItem icon={require('../../../../assets/images/home/icon-paper-mail.png')}>Paper Mails</RecycleItem>
                <RecycleItem icon={require('../../../../assets/images/home/icon-carton-boxes.png')}>Carton boxes</RecycleItem>
            </View>
            <View style={{flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-around', marginBottom: 20}}>
                <RecycleItem icon={require('../../../../assets/images/home/icon-pet-plastic.png')}>P.E.T Bottles</RecycleItem>
            </View>
            <View style={{alignItems: 'center', justifyContent: 'center', marginBottom: 20}}>
                <Image source={require('../../../../assets/images/home/arrow-down.png')} />
            </View>

            <View style={{alignItems: 'center'}}>
                <Image source={require('../../../../assets/images/wecycle-bin.png')}/>
            </View>

            <View style={{backgroundColor: 'rgba(0,0,0,0.3)', margin: 30, marginTop: 15, borderRadius: 10, padding: 10}}>
                <Text style={{color: 'white', textAlign: 'center', fontSize: 16}}><Text style={{color: '#a0ca45', fontWeight: 'bold'}}>Note:</Text> Just flatten
                    your package and put them directly into the bin (no need to put them in a bag)</Text>
            </View>
        </View>
    </View>
)